export default __webpack_public_path__ + "static/media/Heater-Shield of the Fallen Empire.2aa1963f.jpg";